import SkeletonLine from './SkeletonLine';

export default SkeletonLine;
